export const LANG_REGEX = /\/(\w{2})\//;

const DEFAULT_LANG = 'en';

export const urlLang = () => {
    const pathName = window.location.pathname;
    return pathName.replace(LANG_REGEX, '$1')?.toLowerCase() || DEFAULT_LANG;
};

export const hasLanguage = () => !!window.location.pathname.replace(LANG_REGEX, '$1');
